// Settings → Routes index.

import { useAppData } from "../store";
import { Btn } from "../components/Primitives";
import { Ic } from "../components/Icon";

interface Props { onOpen: (id: string) => void; }

export function RoutesScreen({ onOpen }: Props) {
  const { data, saveConfig } = useAppData();
  const routes = data?.config.routes ?? [];

  const newRoute = async () => {
    if (!data) return;
    const id = `route-${Date.now()}`;
    const next = {
      ...data.config,
      routes: [
        ...routes,
        { id, name: "New route", desc: "", fields: 0, rules: 0, default: false },
      ],
    };
    await saveConfig(next);
    onOpen(id);
  };

  return (
    <div className="page">
      <div className="topbar">
        <span className="crumb">Settings</span>
        <span className="crumb-sep">/</span>
        <h1>Routes</h1>
        <span className="grow" />
        <Btn ico="plus" kind="primary" size="sm" onClick={newRoute}>New route</Btn>
      </div>
      <div className="scroll" style={{ padding: "22px 28px 60px" }}>
        <p style={{ color: "var(--ink-2)", fontSize: 13, maxWidth: 540, margin: "0 0 22px" }}>
          Each route defines fields, rules, and enrichments. Inbound deals are
          matched to a route automatically.
        </p>
        <div style={{
          background: "var(--surface)", border: "1px solid var(--border)",
          borderRadius: 8, overflow: "hidden",
        }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "2.2fr 2.4fr 80px 80px 60px",
            padding: "12px 18px", fontSize: 10.5, color: "var(--ink-3)",
            textTransform: "uppercase", letterSpacing: "0.08em",
            fontWeight: 500, borderBottom: "1px solid var(--border)",
            background: "var(--bg)",
          }}>
            <span>Route</span>
            <span>Description</span>
            <span>Fields</span>
            <span>Rules</span>
            <span />
          </div>
          {routes.map((r, i) => (
            <div key={r.id} className="row" style={{
              display: "grid",
              gridTemplateColumns: "2.2fr 2.4fr 80px 80px 60px",
              gap: 0, padding: "14px 18px",
              borderBottom: i < routes.length - 1 ? "1px solid var(--border)" : "none",
            }} onClick={() => onOpen(r.id)}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontWeight: 500, fontSize: 13.5 }}>{r.name}</span>
                {r.default && <span className="pill" style={{ fontSize: 10 }}>Default</span>}
              </div>
              <span style={{ color: "var(--ink-2)", fontSize: 12.5 }}>{r.desc}</span>
              <span className="score" style={{ fontSize: 13 }}>{r.fields}</span>
              <span className="score" style={{ fontSize: 13 }}>{r.rules}</span>
              <span style={{
                color: "var(--ink-3)", fontSize: 12,
                display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4,
              }}>
                Edit <Ic name="chevR" size={12} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
